import { Button, InputFieldCompact } from '@swegon-core/uic';
import { Share } from '@swegon-core/uic/dist/src/theme/icons/googleMaterialIcons';
import { useContext, useState } from 'react';
import { Context as TranslationContext } from '../shared/contexts/TranslationContext';
import { ShareLinkContainer } from './ShareUnit.styles';

interface ShareUnitProps {
    linkUrl: string;
}

const ShareUnit = ({ linkUrl }: ShareUnitProps) => {
    const { l } = useContext(TranslationContext);
    const [buttonLabel, setButtonLabel] = useState(
        l('ahuDesignLite.shareUnitCopyLink')
    );
    return (
        <ShareLinkContainer>
            <InputFieldCompact
                id="share-unit-field"
                label={l('ahuDesignLite.shareUnitDescription')}
                type="text"
                value={linkUrl}
                onChange={() => {}}
                onFocus={() =>
                    (
                        document.getElementById(
                            'share-unit-field'
                        ) as HTMLInputElement
                    ).select()
                }
                readOnly={true}
            />
            <div>
                <Button
                    buttonType="text"
                    onClick={() => {
                        navigator.clipboard.writeText(linkUrl);
                        setButtonLabel(l('ahuDesignLite.shareUnitLinkCopied'));
                    }}
                    label={buttonLabel}
                    icon={Share}
                />
            </div>
        </ShareLinkContainer>
    );
};

export default ShareUnit;
